var map = {
	"./annual-flux.png": 24813,
	"./building-mask.png": 48203,
	"./building-polygon.png": 33993,
	"./building-preservation.png": 60745,
	"./conservation-areas.png": 21666,
	"./digital-surface.png": 24848,
	"./flood-risk.png": 73776,
	"./hourly-shade.png": 24143,
	"./monthly-flux.png": 66382,
	"./near-by-polygon.png": 35283,
	"./properties-with-certificate-of-immunity.png": 13081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38679;